import styled from '@emotion/styled';
import { Loading as LoadingComponent } from '../../components/Loading';

export const Loading = styled(LoadingComponent)`
  height: 100vh;
`;
